
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
import CustomTagMixin from '@/@next/mixins/CustomTag'
import addProtocol from '@/@next/helpers/addProtocol'
import { smallerImageUrl } from '@/@next/helpers'

const config = {
  name: 'c-content-image',
  components: {
    CImage,
    CLoader
  }
}

@Component(config)
export default class Image extends Mixins(CustomTagMixin) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: String, required: false, default: '' }) contextId!: string

  smallerImageUrl = smallerImageUrl

  get image () {
    if (!this.content) return null
    return this.content.data.i18n.image.value
  }

  get imageId () {
    if (!this.content) return null
    return this.content.data.i18n.image.value.id
  }

  get title () {
    if (!this.content) return null
    return this.content.data.i18n.title.value
  }

  get description () {
    if (!this.content) return null
    return this.content.data.i18n.description.value
  }

  get backUpUrl () {
    if (!this.image) return null
    const url = this.smallerImageUrl(this.image)
    if (!url) return null
    return addProtocol(url)
  }

  get query () {
    const query = {
      context: 'poi',
      context_id: this.contextId,
      content_id: this.content.id
      }
    if (!this.backUpUrl) return query
    return { ...query, backUpUrl: this.backUpUrl }
  }

}
